
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/players/[slug]",
      function () {
        return require("private-next-pages/players/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/players/[slug]"])
      });
    }
  